import { useQuery, useQueryClient } from '@tanstack/react-query';

const useAsyncData = (queryKey, loader, immediate = true, options = {}) => {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: loader,
    enabled: immediate,
    keepPreviousData: true,
    ...options,
  });

  const reload = async () => {
    const result = await query.refetch();
    return result.data ?? null;
  };

  return {
    data: query.data ?? null,
    setData: (updater) => queryClient.setQueryData(queryKey, updater),
    loading: query.isLoading,
    updating: query.isFetching && !query.isLoading,
    error: query.error?.message || '',
    reload,
  };
};

export default useAsyncData;
